import { render, staticRenderFns } from "./QuotationDetail.vue?vue&type=template&id=104dd8fe&scoped=true&"
import script from "./QuotationDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetail.vue?vue&type=style&index=0&id=104dd8fe&lang=scss&scoped=true&"
import style1 from "./QuotationDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104dd8fe",
  null
  
)

export default component.exports